import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-215">
      <div className="max-w-3xl mx-auto" data-id="element-216">
        <div ref={fadeIn.ref} className={`space-y-6 md:space-y-8 text-base md:text-xl ${fadeIn.className}`} data-id="element-217">
          <div className="text-center mb-8 md:mb-12" data-id="element-218">
            <h2 className="text-2xl md:text-4xl font-black text-yellow-400 mb-4 md:mb-6" data-id="element-219">
              💔 ¿Sentís que el tiempo pasa y cada vez comparten menos?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-220">
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-221">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-222">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-223">
                Las pantallas reemplazaron las charlas en la mesa y los juegos
                en el living.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-224">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-225">🥱</div>
              <p className="text-gray-300 font-medium" data-id="element-226">
                Llega el fin de semana y terminan haciendo siempre lo mismo por
                falta de ideas.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-227">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-228">💸</div>
              <p className="text-gray-300 font-medium" data-id="element-229">
                Creés que para divertirse con tu hija hay que gastar mucho
                dinero o salir de casa.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-230">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-231">⏳</div>
              <p className="text-gray-300 font-medium" data-id="element-232">
                Los chicos crecen rápido y sentís que te estás perdiendo de
                crear recuerdos reales.
              </p>
            </div>
          </div>

          <div className="text-center mt-8 md:mt-12 space-y-3 md:space-y-4" data-id="element-233">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-234">
              No es falta de amor. Es la rutina que nos consume. ❤️
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-235">
              Querés pasar tiempo de calidad con ellos. Pero a veces falta la
              chispa para empezar.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-3 md:mt-4" data-id="element-236">
              Entre el trabajo, la casa y las obligaciones, es normal quedarse
              sin energía para inventar juegos o planear actividades que a todos
              les gusten.
            </p>
          </div>

          <div className="bg-gray-900 p-6 md:p-8 rounded-xl border border-yellow-500 mt-8 md:mt-12 shadow-2xl" data-id="element-237">
            <div className="space-y-4 md:space-y-6 text-gray-300" data-id="element-238">
              <p className="flex items-start gap-3" data-id="element-239">
                <span className="text-xl md:text-2xl" data-id="element-240">🔑</span>
                <span className="font-bold text-white" data-id="element-241">
                  Lo que necesitás es un sistema simple que elimine la fricción
                  de planear y los invite a jugar al instante.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-242">
                <span className="text-xl md:text-2xl" data-id="element-243">🃏</span>
                <span data-id="element-244">
                  Con el Pack 100 Citas con mi Hija vas a tener 100 ideas listas
                  para usar. Solo eligen una cita y la diversión empieza.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-245">
                <span className="text-xl md:text-2xl" data-id="element-246">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-247">
                  ¿Y si hoy fuera el día que empiezan a crear los recuerdos de
                  su infancia? 💙
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}